import { httpClient } from '@/network/clientController'

/** Gets List of TPAs requested
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GETtpaRequestlist
*/
export const getListTPAsRequested = payload => {
	return httpClient({
		method: 'GET',
		url: 'tpaRequest/list',
		isCancellable: true,
		params: payload
	})
}

/** Gets List of TPAs Types available for request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequesttpatypes
*/
export const getListTPAsTypesAvailableForRequest = payload => {
	return httpClient({
		method: 'GET',
		url: 'tpaRequest/tpaTypes',
		isCancellable: true
	})
}

/** Validates NIF for TPAs request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestvalidateNif
*/
export const validatesNIFForTPAsRequest = payload => {
	return httpClient({
		method: 'GET',
		url: 'tpaRequest/validateNif',
		isCancellable: true
	})
}

/** Calculates Taxes for TPAs request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestcalculate
*/
export const calculatesTaxesForTPAsRequest = payload => {
	return httpClient({
		method: 'GET',
		url: 'tpaRequest/calculate',
		params: payload,
		isCancellable: true
	})
}

/** Validates Amount for TPAs request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestvalidateAmount
*/
export const validatesAmountForTPAsRequest = payload => {
	return httpClient({
		method: 'GET',
		url: 'tpaRequest/validateAmount',
		params: payload,
		isCancellable: true
	})
}

/** Get Company Data for TPAs request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestcompanyData?parent=Web_API
*/
export const getCompanyDataForTPAsRequest = payload => {
	return httpClient({
		method: 'GET',
		url: 'tpaRequest/companyData',
		isCancellable: true
	})
}

/** Submit TPAs request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_tpaRequestsubmit
*/
export const submitTPAsRequest = payload => {
	return httpClient({
		method: 'POST',
		url: 'tpaRequest/submit',
		data: payload,
		operationTypeId: 2006 /* for mocks handling of tokens */
	})
}
